import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import autoBind from 'react-autobind';

import gql from 'graphql-tag';
import { resultHasErrors } from 'utils/graphql-errors';

class ThinkificSSO extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async viewCourseContent() {
    const { client } = this.props;

    try {
      const result = await client.mutate({
        mutation: gql`
          mutation viewCourseContent {
            viewCourseContent
          }
        `,
      });

      const { data, errors } = result;

      if (resultHasErrors({ errors })) {
        console.log(errors);
      } else {
        const { viewCourseContent } = data;

        if (viewCourseContent) {
          console.log('SUCCESS');
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getTokenSSO() {
    this.viewCourseContent();

    const { client } = this.props;

    try {
      const result = await client.mutate({
        mutation: gql`
          mutation generateThinkificSSO {
            generateThinkificSSO
          }
        `,
      });

      const { data, errors } = result;

      if (resultHasErrors({ errors })) {
        alert("You can't access this link");
      } else {
        const { generateThinkificSSO } = data || {};
        window.open(generateThinkificSSO, '_blank');
      }
    } catch (error) {
      console.log(error);
    }
  }
  render() {
    return (
      <div onClick={() => this.getTokenSSO()}>
        <FormattedMessage id="app.layout.header.thinkific" defaultMessage="My Courses" />
      </div>
    );
  }
}

export default withRouter(withApollo(injectIntl(ThinkificSSO)));



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/thinkific-sso.js